// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job_name {
  font-size: 11px !important;
  box-sizing: border-box !important;
  border: none !important;
  box-shadow: 1px 1px 2px 2px lightgrey !important;
  outline: 0 !important;
  background-color: #fff !important;
  color: rgba(0, 0, 0, 0.87) !important;
  width: 100% !important;
  padding: 0 15px !important;
  line-height: 30px !important;
  height: 30px !important;
  border-radius: 5px !important;
  padding-left: 5px !important;
  padding-right: 9% !important;
}

.modified_by {
  font-size: 11px !important;
  box-sizing: border-box !important;
  border: none !important;
  box-shadow: 1px 1px 2px 2px lightgrey !important;
  outline: 0 !important;
  background-color: #eceeef !important;
  opacity: 1;
  color: rgba(0, 0, 0, 0.87) !important;
  width: 100% !important;
  padding: 0 15px !important;
  line-height: 30px !important;
  height: 30px !important;
  border-radius: 5px !important;
  padding-left: 5px !important;
  padding-right: 9% !important;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.failed_card {
  border-left: 4px solid #da606c;
}

::ng-deep.jobmodal .modal-dialog {
  max-width: 97% !important;
  max-height: 40% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.jobmodal {
  top: 4% !important;
}

.job_text_field {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.job_text {
  color: black;
  top: 7px;
}

.mat-mdc-icon-button.mat-mdc-button-base {
  display: none !important;
}

::ng-deep.jobpaginator .mat-mdc-tooltip-trigger.mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none !important;
}

/* Keep the JOBS log modal footer visible by confining scrolling to the body. */
.jobs-log-modal {
  display: flex;
  flex-direction: column;
  height: 72vh;
  max-height: calc(100vh - 140px);
  overflow: hidden;
}

.jobs-log-modal .modal-header {
  flex: 0 0 auto;
}

.jobs-log-modal__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 0.75rem;
}

.jobs-log-modal__footer {
  position: sticky;
  bottom: 0;
  z-index: 1;
  flex: 0 0 auto;
  background-color: #fff;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);
}

.jobs-log-modal__footer .d-flex {
  width: 100%;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.jobs-log-modal__footer .jobpaginator {
  flex: 1 1 260px;
}`, "",{"version":3,"sources":["webpack://./src/app/job/job.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,gDAAA;EACA,qBAAA;EACA,iCAAA;EACA,qCAAA;EACA,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;AACF;;AAEA;EACA,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,gDAAA;EACA,qBAAA;EACA,oCAAA;EACA,UAAA;EACA,qCAAA;EACA,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;AACA;;AAEA;EACE,8BAAA;AACF;;AACA;EACE,8BAAA;AAEF;;AAAA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAGF;;AADA;EACE,kBAAA;AAIF;;AAFA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAKF;;AAFA;EACE,YAAA;EACE,QAAA;AAKJ;;AAFA;EACE,wBAAA;AAKF;;AAAG;EACC,wBAAA;AAGJ;;AAEA,+EAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,+BAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,0CAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".job_name{\r\n  font-size: 11px !important;\r\n  box-sizing: border-box !important;\r\n  border: none !important;\r\n  box-shadow: 1px 1px 2px 2px lightgrey!important;\r\n  outline: 0 !important;\r\n  background-color: #fff !important;\r\n  color: rgba(0, 0, 0, 0.87) !important;\r\n  width: 100% !important;\r\n  padding: 0 15px !important;\r\n  line-height: 30px !important;\r\n  height: 30px !important;\r\n  border-radius: 5px !important;\r\n  padding-left: 5px !important;\r\n  padding-right: 9% !important;\r\n}\r\n\r\n.modified_by{\r\nfont-size: 11px !important;\r\nbox-sizing: border-box !important;\r\nborder: none !important;\r\nbox-shadow: 1px 1px 2px 2px lightgrey!important;\r\noutline: 0 !important;\r\nbackground-color: #eceeef!important;\r\nopacity: 1;\r\ncolor: rgba(0, 0, 0, 0.87) !important;\r\nwidth: 100% !important;\r\npadding: 0 15px !important;\r\nline-height: 30px !important;\r\nheight: 30px !important;\r\nborder-radius: 5px !important;\r\npadding-left: 5px !important;\r\npadding-right: 9% !important;\r\n}\r\n\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n::ng-deep.jobmodal .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height:40%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.jobmodal{\r\n  top: 4%!important;\r\n}\r\n.job_text_field{\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n}\r\n\r\n.job_text{\r\n  color: black;\r\n    top: 7px;\r\n}\r\n\r\n.mat-mdc-icon-button.mat-mdc-button-base  {\r\n  display: none !important;\r\n}\r\n\r\n::ng-deep.jobpaginator{\r\n  .mat-mdc-tooltip-trigger.mat-mdc-icon-button{\r\n   .mat-mdc-button-persistent-ripple {\r\n    display: none !important;\r\n  }\r\n}\r\n}\r\n\r\n/* Keep the JOBS log modal footer visible by confining scrolling to the body. */\r\n.jobs-log-modal {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 72vh;\r\n  max-height: calc(100vh - 140px);\r\n  overflow: hidden;\r\n}\r\n\r\n.jobs-log-modal .modal-header {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.jobs-log-modal__body {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  padding-bottom: 0.75rem;\r\n}\r\n\r\n.jobs-log-modal__footer {\r\n  position: sticky;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  flex: 0 0 auto;\r\n  background-color: #fff;\r\n  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.jobs-log-modal__footer .d-flex {\r\n  width: 100%;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.jobs-log-modal__footer .jobpaginator {\r\n  flex: 1 1 260px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
